export default {"src":"/_next/static/media/home-store-icon.7fdd081e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};